<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'

definePageMeta({
  layout: 'partners',
})

const { t, locale } = useI18n()

const paragraphs = ['values', 'agreement', 'activities', 'goal']

useHead(() => ({
  title: t('pageTitles.partnersFairPlay.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.partnersFairPlay.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.partnersFairPlay.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.partnersFairPlay.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.partnersFairPlay.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.partnersFairPlay.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <div>
    <InvestorHero
      :title="$t('partners.fairPlay.title')"
      :lead="$t('partners.fairPlay.lead')"
    />

    <section class="section-investor">
      <div class="fair-play section-investor__container">
        <p
          v-for="paragraph in paragraphs"
          :key="paragraph"
          class="fair-play__text"
        >
          {{ $t(`partners.fairPlay.${paragraph}`) }}
        </p>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
:deep(.investorHero__content) {
  align-items: center;
  align-self: center;
  text-align: center;
}

.fair-play {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
  text-align: center;

  &__text {
    @include body-1;
    max-width: 80rem;
    color: $text-400;
  }
}
</style>
